$(document).ready(function () {
  $(".testimonials-slider").slick({
    slidesToShow: 1,
    arrows: true,
  });
$(".arrow-down-slider").slick({
    slidesToShow: 1,
    arrows: true,
  });
  
  $(".dermatologists-video-slider").slick({
    slidesToShow: 3,
    dots: true,
    arrows: false,
    
        responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          centerMode: true,
        }
      }      
    ]
  });

  $(".reason-to-use-steez-slider").slick({
    slidesToShow: 3,
    dots: false,
    arrows: true,

       responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,          
        }
      },
         {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      },     
    ]
  });

  $(".competitor-column-slider").slick({
    slidesToShow: 3,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: true,
          infinite: false,
        }
      }
    ]
    

  });

  
  $(".mood-slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });
  /*$('.customer-reviews-video-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      const currentSlideElement = $(slick.$slides[currentSlide]);
      const currentVideo = currentSlideElement.find('video').get(0);
  
      if (currentVideo) {
          currentVideo.pause();
          currentSlideElement.find('.video-open-icon').show(); // Correct jQuery way to select the sibling
          currentSlideElement.find(".fa-play").show();
          currentSlideElement.find(".fa-pause").hide();
      }
  });*/

});

// $(".product-form__quantity, .product-buy-btn-wrap").wrapAll("<div class='wrap-quantity-and-cart-btn'></div>");


jQuery(document).ready(function(){
            new Splide(".multicolumn-slider", {
            type: "loop",
            perPage: 3,
            arrows: false,
            autoWidth: true,
            pagination: false,
            focus: "center",          
            gap: "100px",
            autoScroll: {
            speed: 2,
            pauseOnHover: false,
            },
            breakpoints: {
              900: {
                perPage: 2,
                gap: "30px",
              },
            },
            }).mount(window.splide.Extensions);

      });

// $(".multicolumn-slider").slick({
//  slidesToShow: 3,
//   slidesToScroll: 1,
//   autoplay: true,
//   infinite: true,
//   autoplaySpeed: 0,
//   speed: 4000,
//   pauseOnHover: false,
//   dots: false,
//   arrows: false,
//   cssEase: 'linear',
//     responsive: [
//       {
//         breakpoint: 900,
//         settings: {
//           slidesToShow: 2,
//         }
//       },
//     ]

  
//   });

//   jQuery(document).ready(function($) {
//   $('.multicolumn-slider').slick({
//     speed: 5000,
//     autoplay: true,
//     autoplaySpeed: 0,
//     centerMode: true,
//     cssEase: 'linear',
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     variableWidth: true,
//     infinite: true,
//     initialSlide: 1,
//     arrows: false,
//     buttons: false
//   });
// });



// let $slider = $(".multicolumn-slider");


// $slider.on("init", function () {
//   $slider.find(".slick-slide").clone().appendTo($slider);
// });

// $slider.slick({
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   infinite: true,
//   autoplay: true,
//   autoplaySpeed: 0,
//   speed: 6000,      
//   cssEase: "linear",
//   pauseOnHover: false,
//   pauseOnFocus: false,
//   arrows: false,
//   dots: false,
//   responsive: [
//     {
//       breakpoint: 900,
//       settings: {
//         slidesToShow: 2,
//       },
//     },
//   ],
// });


jQuery('body').on('click', '.sls-option-container', function(){
    //console.log(jQuery(this).find('label').text());
    if(jQuery(this).find('label').text() == "One-time purchase"){
        jQuery('.product__column-sticky .subscription-rules ').hide();
    }else{
        jQuery('.product__column-sticky .subscription-rules ').show();
    }
});



document.addEventListener('DOMContentLoaded', function() {
  const quantitySelector = document.querySelector('.product-form__quantity');
  const buttonsContainer = document.querySelector('.product-form__buttons');
  
  if (quantitySelector && buttonsContainer) {
    buttonsContainer.prepend(quantitySelector);
  }
});


